<template>
    <div class="base unselectable">
      <!----
        <div v-if="question.type == 'intro'">
          <h2>Lieber Interessent,</h2>
          <div class="selection">
            <p>
                  willkommen bei myFred, Deiner individuellen Ernährungslösung. </p>
                  <p>Verschiedene Einrichtungen und Institute haben in den vergangenen Jahren bereits im Kontext individueller Nahrungsmittel geforscht und das enorme Potenzial für jeden Einzelnen, aber auch die Menschheit an sich herausgearbeitet.
                    </p>
                    <p>
                  Das Ergebnis: Individuelle Nahrungsmittel können gezielt dabei helfen, Mangelernährungen vorzubeugen, indem auf die persönlichen Ernährungsgewohnheiten, etc. eingegangen und diese mit den neuesten wissenschaftlichen Erkenntnissen verknüpft werden.</p>
                  <p>Dabei stehst Du und Dein Alltag im Mittelpunkt. </p>
                  <p>
                  Damit auch Du von den Vorteilen einer personalisierten Mahlzeit profitieren kannst, gibt es zwei mögliche Wege:</p>
                  <p>
                  Für eine erste oberflächliche Analyse bieten wir Dir das nachfolgende kostenfreie Tool an, mit dem wir Dir bereits eine kalorienoptimierte Ernährung anhand Deiner Essgewohnheiten anbieten können. </p>
                  <p>
                  Der zweite Weg ist die Königsdisziplin: Ein*e Ernährungsberater*in wird sich mit Dir in Verbindung setzen, um einen tiefgreifenden Gesundheits- und Ernährungscheck mit Dir durchzuführen. Neben einem Gutachten und Empfehlungen zum Erhalt Deiner persönlichen Gesundheit erhältst Du ebenfalls eine bis in die Haarspitzen optimierte Produktempfehlung von uns. Gerne begleiten wir Dich hier auch bei der Durchführung von Blut- und/ oder Genuntersuchungen und bei der kontinuierlichen Anpassung des Nährstoffprofils Deines myFred.
            </p>
            </div>
            <div class="flex justify-center self-center gap-4">
              <div class="hoverme">
            <button
              :style="specialHeight_Width"
              style="flex-direction: column; max-width: 220px; justify-content: center"
              class="btn_styles mt-2 mb-2 self-center h-20 "
                
                @click="next()"
              >
              Hier geht's zum Tool
            </button>
              </div>
              <div class="hoverme">
            <a :style="specialHeight_Width"
              style="flex-direction: column; max-width: 220px; justify-content: center"
              class="btn_styles mt-2 mb-2 self-center h-20 "
              href="https://www.google.de">Hier geht's zur Ernährungsberatung</a>
              </div>
            </div>
        </div> --->
        <div v-if="question.type == 'multiple'">
          <h2>{{ proccessedQuestion }}</h2>
          <p v-if="question.sub">{{ question.sub }}</p>
          <div v-if="question.info">
            <div style="max-width: 30rem; border-radius: 15px;" class="svg_div bg-lightgreen" role="alert">
                  <svg class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
                  <p>Zusätzliche Inhaltsstoffe: {{question.info}}</p>
              </div>
          </div>
          <div v-if="question.bmi && person.bmi">
            <div v-if="person.bmi <18 || person.bmi>25">
              <span >Dein BMI beträgt {{person.bmi}}</span>
              <div style="max-width: 30rem; border-radius: 15px;" class="svg_div bg-lightgreen" role="alert">
                <svg class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
                <p>{{suggestion}}</p>
              </div>
            </div>
            <div v-else-if="person.bmi >= 18 && person.bmi <= 25" style="max-width: 30rem; border-radius: 15px;" class="svg_div bg-lightgreen" role="alert">
              <svg class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
              <p>{{suggestion}}</p>
            </div>
          </div>
          <div class="selection">
            <div v-for="option in question.options" :key="option.value" class="hoverme flex justify-center self-center" :class="{ horizontal: question.horizontal == true}">
              <button
              :style="specialHeight_Width"
              style="flex-direction: column; max-width: 220px; justify-content: space-between"
              class="btn_styles  mb-2"
                :class="{ selected: answer == option.value, fixedh: question.fixed == true, horizontal: question.horizontal == true}"
                @click="(answer = option.value), next()"
              >
                <img
                  v-if="option.icon"
                  class="icon white-pic noHover"
                  :class="{ iconh: question.fixed == true}"
                  :src="`https://your-fred.web.app${option.icon}`"
                />
                {{ option.text }}
                <div class="description" v-if="option.description"><hr>
                  {{ option.description }}
                </div>
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="question.type == 'number'">
            <h2>{{ proccessedQuestion }}</h2>
            <p>{{ question.sub }}</p>
            <div v-if="question.deficit" style="margin-bottom: 1rem">
              Wir empfehlen dir für deine gewünschten {{answers['weightAmount']}} Kilogramm eine Zeitspanne von {{ recommendation }} Wochen.
            </div>
            <input
                class="m-auto px-2 py-1 text-left mt-8 mb-8 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 block max-w-xl border-gray-300 rounded-md" 
                type="number" v-model="answer" @keyup.enter="nextEmited" :placeholder="question.ph" />
            <div v-if="question.deficit">
              <div v-if="answers['weeks'] && answers['weeks'] != 0" style="max-width: 30rem; border-radius: 15px;" class="svg_div bg-lightgreen" role="alert">
                  <svg class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
                  <p>Um dein Ziel zu erreichen müsstest du auf <u class="text-white">{{showCal}} Kcal</u> am Tag verzichten</p>
              </div>
            </div>
        </div>
        <div v-else-if="question.type == 'text'">
            <h2>{{ proccessedQuestion }}</h2>
            <input
                style="width: 16.25rem;"  @keyup.enter="nextEmited"
                class="m-auto px-2 py-1 text-left mt-8 mb-8 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 block max-w-xl border-gray-300 rounded-md"
                type="text" v-model="answer" :placeholder="question.ph"/>
        </div>
        <div v-else-if="question.type == 'email'">
            <h2>{{ proccessedQuestion }}</h2>
            <input
                style="width: 16.25rem;"  @keyup.enter="nextEmited"
                class="m-auto px-2 py-1 text-left mt-8 mb-8 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 block max-w-xl border-gray-300 rounded-md"
                type="email" v-model="answer" :placeholder="question.ph"/>
            <div class="form-check max-w-xl m-auto text-left flex">
              <input class="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-emerald checked:border-emerald focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" value="" id="flexCheckDefault">
              <label class="form-check-label inline-block text-gray-800" for="flexCheckDefault">
                Ich möchte personalisierte, exklusive Angebote, Neuigkeiten und Newsletter erhalten und habe die Datenschutzerklärung gelesen.
              </label>
          </div>
        </div>
        <div v-else-if="question.type == 'date'">
            <h2>{{ proccessedQuestion }}</h2>
            <p>{{ question.sub }}</p>
            <input 
                style="width: 16.25rem;"  @keyup.enter="nextEmited"
                class="m-auto px-2 py-1 text-left mt-8 mb-8 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 block max-w-xl border-gray-300 rounded-md"
                type="date" v-model="answer" :placeholder="question.ph"/>
        </div>
        <div v-else-if="question.type == 'multiselect'">
            <h2>{{ proccessedQuestion }}</h2>
            <p>{{ question.sub }}</p>
            <div class="multiselect">
                <div v-for="option in question.options" :key="option.value" class="hoverme">
                  <button
                  class="btn_styles "
                    :class="{ 'selected': (answer || []).includes(option.value) }"
                    @click="
                      (answer || []).includes(option.value)
                        ? (answer = answer.filter((y) => y != option.value))
                        : (answer.push(option.value),
                          answer.length > question.max ? answer.shift() : '')">
                    <img
                      v-if="option.icon"
                      class="top-icon white-pic noHover mr-2"
                      :src="`https://your-fred.web.app${option.icon}`"/>
                    {{ option.text }}
                      <div class="description" v-if="option.description">
                        {{ option.description }}
                      </div>
                  </button>
                </div>
                <div class="hoverme">
                <button v-if="question.none"
                    class="btn_styles "
                    @click="emptyAnswer">
                    <img v-if="question.noneIcon" class="top-icon white-pic noHover mr-2" :src="`https://your-fred.web.app${question.noneIcon}`"/>
                    {{question.noneText}}
                  </button>
                </div>
            </div>
        </div>
        <div v-else-if="question.type == 'sportMultiple'">
            <h2>{{ proccessedQuestion }}</h2>
            <div style="margin-top: 2rem; margin-bottom: 2rem">
              <div class="sportmultiple" style="width: 44%; justify-content: space-between">
              <div class="borderbox_special box1">Leichte sportliche Betätigung, ohne Schwitzen oder Kurzatmigkeit</div>
              <div class="borderbox_special box2">Anstrengende, aber nicht überstrapazierende sportliche Betätigung</div>
              <div class="borderbox_special box3">Massive und sehr anstrengende sportliche Betätigung</div>
              </div>
            <div v-for="(answer1, idx) in answers['sport']" :key="answer1.value" class="mb-4">
              
              <div class="flexcenter gap">
              <img
                      class="top-icon noHover mr-4"
                      :src="`https://your-fred.web.app${question.icons[answer1]}`"/>
              <input type="range" v-model="answer[answers['sport'][idx]]" :min="0" :max="100"/>
              {{answer[idx]}}
            </div>
            </div>
            </div>

        </div>
        <div v-else-if="question.type == 'sportNumber'">
            <h2>{{ proccessedQuestion }}</h2>
            <div style="margin-bottom: 2rem; margin-top: 2rem">
            <div v-for="(answer1, idx) in answers['sport']" :key="answer1.value" style="margin-bottom: 1rem">
              <div class="flexcenter gap">
              <img
                      class="top-icon noHover mr-4"
                      :src="`https://your-fred.web.app${question.icons[answer1]}`"/>
              <input 
                class="px-2 py-1 text-left mb-2 mt-2 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 max-w-xl border-gray-300 rounded-md" 
                type="number" v-model="answer[answers['sport'][idx]]" :placeholder="question.ph" />
              </div>
            </div>
            </div>
        </div>
        <div v-else-if="question.type == 'slider'">
            <h2>{{ proccessedQuestion }}</h2>
            <p>{{ question.sub }}</p>
            <div class="flexcenter" style="margin-bottom: 2rem; margin-top: 2rem">
            <span style="margin-right: 0.5rem"><img
                  v-if="question.options[0].icon"
                  class="icon noHover"
                  :class="{ iconh: question.fixed == true}"
                  :src="`https://your-fred.web.app${question.options[0].icon}`"
                /></span>
            <input type="range" v-model="answer" :min="0" :max="100"/>
            <span style="margin-left: 0.5rem"><img
                  v-if="question.options[2].icon"
                  class="icon noHover"
                  :class="{ iconh: question.fixed == true}"
                  :src="`https://your-fred.web.app${question.options[2].icon}`"
                /></span>
            </div>
        </div>
    </div> 
</template>

<script>
export default {
  name: 'SurveyQuestion',
  props: {
    value: {},
    question: {
      type: Object,
      required: true
    },
    answers: {
      type: Object,
      required: true
    },
    person: {
      type: Object,
    },
    calorieDeficit: {
      type: Object
    },
    calorieDeficitCalculation: {
      type: Object
    }
  },
  data() {
    return {
      answer: this.value
    }
  },
  watch: {
    answer: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      }
    }
  },
  computed: {
    specialHeight_Width () {
      if (this.question.height) {
      return {
        'min-height': this.question.height +'px' 
      }
      } else if (this.question.width) {
        return {
        width: this.question.width +'px' 
      }
      } else return null
    },
    recommendation () {
      return this.calorieDeficit.recommendedWeeks
    },
    showCal () {
      return this.calorieDeficitCalculation.calorieDeficitPerDay == 'Infinity' ? '0' : Math.round(this.calorieDeficitCalculation.calorieDeficitPerDay)
    },
    suggestion() {
      let sug = ''
      if (this.person.bmi < 18) {
        sug = "Dein BMI ist unter 18, wir empfehlen keine Gewichtsabnahme."
      } else if (this.person.bmi > 25) {
        sug = "Dein BMI ist über 25, wir empfehlen eine Gewichtsabnahme."
      } else {
        sug = `Dein BMI liegt bei ${this.person.bmi} und befindet sich im Normalbereich.`
      }
      return sug
    },
    proccessedQuestion() {
      let question = this.question.question
      for (let i in this.answers) {
        question = question.replace(
          new RegExp('{{' + i + '}}', 'gi'),
          this.answers[i] || ''
        )
      }
      return question
    }
  },
  methods: {
    nextEmited() {
      if (this.answer) {
        setTimeout(() => this.$emit('next'), 100)
      }
    },
    next() {
      setTimeout(() => this.$emit('next'), 100)
    },
    emptyAnswer () {
      this.answer = ['none']
      setTimeout(() => this.$emit('next'), 100)
    }
  },
  mounted() {
    if (this.question.type == "multiselect" && !Array.isArray(this.value)) {
      this.answer = [];
    }
    if (this.question.type == "sportNumber") {
      this.answer = {};
    }
    if (this.question.type == "sportMultiple") {
      if (this.answer === null) {
        this.answer = {}
          let length = this.answers['sport'].length
          for (let i = 0; i < length; i++) {
            this.answer[this.answers['sport'][i]] = 50
          }
      }
    }
  },
created () {
  }
}
</script>
<style>
.bg-blue{
  background-color: #534DA8
}
.bg-lightgreen{
  background-color: #85C7A8
}
.hoverme :hover{
  background-color: #f2f2f2
}
.description{
  font-size: 12px;
}
.selected{
  background-color: #f2f2f2!important
}
h2, p {
  font-family: 'Work Sans', sans-serif
}
.white-pic{
  /* filter:  brightness(0) invert(1); */
}
.noHover{
    pointer-events: none;
}
.rounded-full{
  border-radius: 10px !important
}
.icon{
  height: 50px;
    width: 50px;
}
.fixedh{
  height: 220px
}
.iconh{
  height: 50px;
  width: 50px
}
.horizontal{
  width: 100%;
  max-width: unset!important
}

/* Slider CSS */
input[type=range] {
  height: 25px;
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
  max-width: 600px;
  border: none!important;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: #6E6E6E;
  border-radius: 1px;
  border: 0px solid #000000;
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #000000;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #000000;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: #6E6E6E;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: #8A8AD5;
  border-radius: 1px;
  border: 0px solid #000000;
}
input[type=range]::-moz-range-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #8A8AD5;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #A1D0FF;
  cursor: pointer;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: #8A8AD5;
  border: 0px solid #000000;
  border-radius: 2px;
  box-shadow: 0px 0px 0px #000000;
}
input[type=range]::-ms-fill-upper {
  background: #8A8AD5;
  border: 0px solid #000000;
  border-radius: 2px;
  box-shadow: 0px 0px 0px #000000;
}
input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #8A8AD5;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #A1D0FF;
  cursor: pointer;
}
input[type=range]:focus::-ms-fill-lower {
  background: #8A8AD5;
}
input[type=range]:focus::-ms-fill-upper {
  background: #8A8AD5;
}
.unselectable {
   -moz-user-select: -moz-none;
   -khtml-user-select: none;
   -webkit-user-select: none;

   /*
     Introduced in IE 10.
     See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
   */
   -ms-user-select: none;
   user-select: none;
}
.borderbox_special{
    background-color: #F2F2F2;
    border-radius: 30px;
    padding: 15px;
    width: 30%!important;
    max-width: 500px;
    margin-bottom: 40px;
    height: fit-content;
}
.btn_styles{
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-width: 1px;
    border-color: transparent;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 500;
    border-radius: 10px;
    color: #FFF;
    margin-bottom: 0.5rem;
    gap: 0.5rem;
    background-color: #FFF;
    color: #000000;
    border: 1px solid #000000;
}
.selection_div{
    display: flex;
    justify-content: center;
    margin-top: 0.75rem;
    gap: 1rem
}
.selection{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    max-width: 48rem; 
    margin: auto;
    margin-top: 2rem;
    margin-bottom: 2rem
}
.multiselect{
    display: flex;
    flex-wrap: wrap;
    max-width: 56rem;
    margin: auto;
    gap: 0.5rem;
    justify-content: center;
    margin-top: 2rem;
    margin-bottom: 2rem
}
.sportmultiple{
    display: flex;
    margin-left: auto;
    margin-right: auto;
    align-items: flex-start;
}
.flexcenter{
    display: flex;
    justify-content: center;
    align-items: center;
}
.gap{
  gap: 0.5rem
}
.svg_div{
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 700;
    padding: 1rem 0.75rem;
    margin-top: 2rem;
}
.svg{
    fill: currentColor;
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem
}
.svg_div p{
  margin: unset
}
.base h2{
  margin: auto;
  margin-top: 20px;
  max-width: 80%;
  font-size: 2rem;
}

@media (max-width: 768px) {
  .absoulute-fixer{
    padding-left: 20px!important;
    padding-right: 20px!important;
  }
  .sportmultiple{
    width: 100%!important;
  }
  .borderbox_special{
    hyphens: auto;
  }
}
</style>
